module.exports = __webpack_public_path__ + "static/img/select_arrow.c27113b1.svg";